<template>
    <div>
        <section v-if="paso1" class="padding-vertical-content white-content right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + manager.bg2_url + ")"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6 col-xl-5">
                                <div v-if="loading">
                                    <LoaderComponent/>
                                </div>
                                <h2 class="m-0 mt-5 h1 text-uppercase">{{ $t('home.renovar_bcb') }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5"> {{ $t('renovar_abono.temporada', { temporada: lista_abonados.nombre }) }}</div>

                                <BuscarAbonadoComponent :abonado="abonado_search" :disabled="paso2" v-on:terminado="buscarAbonado"/>

                                <div v-if="yaRenovado" class="alert alert-warning mt-3">
                                    <i class="fas fa-check-circle mr-1"></i>
                                    {{ $t('renovar_abono.ya_renovado', {abono: teatro.texto_abono}) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="padding-vertical-content" v-if="abonado">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="h2 mb-3 mb-lg-4 d-block">{{ $t('renovar_abono.tus_datos') }}</div>
                        <div class="lightgray-content p-2 p-lg-3 w-100 mb-4">
                            <InformacionAbonadoComponent :abonado="abonado" :asiento="asiento"/>
                        </div>
                    </div>

                    <div class="col-12 border-top pt-4 mt-4" v-if="pasoFamilia" id="pasoFamilia">
                        <div class="h2 mb-3 mb-lg-4 d-block">{{ $t('renovar_abono.familia_titulo', { abonos: teatro.texto_abonos }) }}</div>
                        <div class="lightgray-content p-3">
                            <p class="mb-2">{{ $t('renovar_abono.familia_descripcion', { abonos: teatro.texto_abonos }) }}</p>

                            <div class="alert alert-info p-2 mb-2 d-flex justify-content-start align-items-center" role="alert">
                                <i class="fas fa-info-circle mr-1"></i>
                                {{ $t('renovar_abono.familia_info', { abono: teatro.texto_abono }) }}
                            </div>

                            <div v-if="estadoBadge?.info" class="alert mb-4 p-3" :class="{
                                'alert-success': familias?.estado === 'aprobado',
                                'alert-warning': familias?.estado === 'pendiente',
                                'alert-danger': familias?.estado === 'rechazado'
                            }" role="alert"
                            >
                                <i class="fas fa-info-circle mr-1"></i>
                                {{ estadoBadge.info }}
                                <p
                                    v-if="familias && familias.estado === 'rechazado' && familias.motivo_rechazo"
                                    class="tw:m-0 tw:mt-2"
                                >
                                    <strong>{{ $t('perfil.familia.motivo_rechazo_label') }}:</strong>
                                    {{ familias.motivo_rechazo }}
                                </p>
                            </div>

                            <div class="table-responsive" style="position: relative;">
                                <div v-if="cargandoFamilia" class="familia-loading-overlay">
                                    <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
                                </div>
                                <table class="table table-bordered table-hover mb-0" :class="{ 'tw:opacity-50': cargandoFamilia }">
                                    <thead class="thead-light">
                                        <tr>
                                            <th style="width: 60px" class="text-center">
                                                <ToggleSwitch
                                                    :value="todosDisponiblesSeleccionados"
                                                    @input="seleccionarTodosFamiliares"
                                                    size="sm"
                                                    :disabled="miembrosDisponibles.length === 0"
                                                    :ariaLabel="$t('renovar_abono.familia_seleccionar_todos')"
                                                />
                                            </th>
                                            <th>{{ $t('formularios.nombre') }}</th>
                                            <th>{{ $t('formularios.dni') }}</th>
                                            <th>{{ $t('formularios.n_abonado', { abonado: teatro.texto_abonado }) }}</th>
                                            <th>{{ $t('renovar_abono.familia_ubicacion') }}</th>
                                            <th style="width: 50px" class="text-center" v-if="puedeGestionarFamilia"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="abonado" class="table-primary">
                                            <td class="text-center">
                                                <span class="d-flex align-items-center justify-content-center">
                                                    <ToggleSwitch :value="true" disabled size="sm" />
                                                    <i class="fas fa-info-circle fa-sm text-primary ml-1"
                                                       v-b-tooltip.hover.html="{ title: $t('renovar_abono.familia_abonado_principal', { abonado: teatro.texto_abonado }) }"
                                                    ></i>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="mr-1">{{ abonado.name }} {{ abonado.surnames }}</span>
                                            </td>
                                            <td>{{ abonado.dni }}</td>
                                            <td>{{ abonado.n_abonado }}</td>
                                            <td class="small">{{ ubicacionAbonadoPrincipal }}</td>
                                            <td class="text-center" v-if="puedeGestionarFamilia"></td>
                                        </tr>
                                        <tr v-if="!familiares.length && !abonado">
                                            <td :colspan="puedeGestionarFamilia ? 6 : 5" class="text-center text-muted py-3">
                                                <i class="fas fa-users mr-1"></i>
                                                {{ $t('renovar_abono.familia_sin_miembros') }}
                                            </td>
                                        </tr>
                                        <template v-if="familiares.length">
                                            <tr
                                                v-for="familiar in familiares"
                                                :key="familiar.id"
                                                :class="{
                                                    'table-active': familiaresSeleccionados.includes(familiar.id),
                                                    'text-black-50': familiar.renovado || !familiar.renovable
                                                }"
                                            >
                                                <td class="text-center">
                                                    <span class="d-flex align-items-center justify-content-center">
                                                        <template v-if="familiar.renovado">
                                                            <i class="fas fa-info-circle fa-lg text-muted"
                                                               v-b-tooltip.hover.html="{
                                                                   title: $t('renovar_abono.familia_ya_renovado', { abonado: teatro.texto_abonado })
                                                               }"
                                                            ></i>
                                                        </template>
                                                        <template v-else-if="familiar.renovable">
                                                            <ToggleSwitch
                                                                :value="familiaresSeleccionados.includes(familiar.id)"
                                                                @input="toggleFamiliar(familiar.id)"
                                                                size="sm"
                                                            />
                                                        </template>
                                                        <i v-else
                                                           class="fas fa-info-circle fa-lg text-muted"
                                                           v-b-tooltip.hover.html="{
                                                               title: $t('renovar_abono.familia_sin_asiento_bloqueado')
                                                           }"
                                                        ></i>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="d-flex flex-wrap align-items-center">
                                                        <span class="mr-1">{{ familiar.name }} {{ familiar.surnames }}</span>
                                                        <span v-if="familias?.titular_id == familiar?.id" class="badge badge-warning mr-1 p-1">{{ $t('renovar_abono.familia_badge_titular') }}</span>
                                                        <span v-if="familiar.renovado" class="badge badge-success p-1">{{ $t('renovar_abono.familia_badge_renovado') }}</span>
                                                        <i v-if="familiar.nuevo"
                                                           class="fas fa-times-circle text-danger ml-1"
                                                           style="cursor: pointer; font-size: 0.9rem; vertical-align: middle;"
                                                           v-b-tooltip.hover.html="{ title: $t('renovar_abono.familia_quitar_lista') }"
                                                           @click="quitarMiembro(familiar.id)"
                                                        ></i>
                                                    </span>
                                                </td>
                                                <td>{{ familiar.dni }}</td>
                                                <td>{{ familiar.n_abonado }}</td>
                                                <td class="small">{{ ubicacionFamiliar(familiar) }}</td>
                                                <td class="text-center" v-if="puedeGestionarFamilia">
                                                    <i class="fas fa-trash-alt text-danger"
                                                       style="cursor: pointer; font-size: 1rem;"
                                                       v-b-tooltip.hover.html="{ title: $t('renovar_abono.familia_eliminar_familia') }"
                                                       @click="openModalRemoverMiembro(familiar)"
                                                    ></i>
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-flex justify-content-start mt-3 mb-2">
                                <Button
                                    :label="$t('renovar_abono.familia_anadir')"
                                    @click="openModalAnadirMiembro"
                                />
                            </div>
                            <p class="text-black-50 small mb-1 mt-1">
                                <i class="fas fa-info-circle mr-1"></i>
                                {{ $t('renovar_abono.familia_continuar_sin_miembros') }}
                            </p>
                            <hr class="mt-3 mb-0"/>
                            <div v-if="algunMiembroRenovado" class="alert alert-warning mt-3 mb-0 p-2" role="alert">
                                <i class="fas fa-exclamation-triangle mr-1"></i>
                                {{ $t('renovar_abono.familia_miembro_ya_renovado_aviso') }}
                            </div>
                            <div v-else-if="mostrarAvisoPreciosFamilia" class="alert alert-warning mt-3 mb-0 p-2" role="alert">
                                <i class="fas fa-exclamation-triangle mr-1"></i>
                                {{ $t('renovar_abono.familia_aviso_precios_especiales') }}
                            </div>
                            <div class="pt-3 pb-1 d-flex flex-column align-items-end flex-md-row justify-content-md-between align-items-md-center">
                                <span class="text-black-50 small mb-2 mb-md-0">
                                    {{ $t('renovar_abono.familia_seleccionados', { count: totalSeleccionados }) }}
                                </span>
                                <div class="d-flex align-items-center">
                                    <Button
                                        :label="$t('formularios.atras')"
                                        custom-class="mr-2"
                                        @click="volverAlBuscar"
                                    />
                                    <Button
                                        :label="$t('renovar_abono.familia_continuar')"
                                        @click="continuarSinFamilia"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" v-if="!pasoFamilia">
                        <div v-if="paso3" id="paso3">
                            <div class="d-flex align-items-center mb-3 mb-lg-4">
                                <div class="h2 mr-2">{{ $t('renovar_abono.renovacion_abono', {abono: teatro.texto_abono}) }}</div>
                                <Button label="Volver" size="" @click="familiares.length ? volverAPasoFamilia() : volverAlBuscar()" />
                            </div>
                            <div v-if="teatro?.familia_abonados_activa && pertenece_a_familia && !asiento && !plaza" class="alert alert-warning mb-4" role="alert">
                                <i class="fas fa-exclamation-triangle mr-1"></i>
                                {{ $t('renovar_abono.familia_sin_asiento_principal', { abonado: teatro.texto_abonado }) }}
                            </div>
                            <div class="row flex-lg-nowrap">
                                <div class="col-12 col-lg-4" v-if="asiento">
                                    <label class="d-block h5"><span class="altcolor">A</span>. {{ $t('renovar_abono.asiento_anterior') }}</label>
                                    <div class="lightgray-content p-2 p-lg-3 mb-3">
                                        <ul class="info-list list-unstyled w-100">
                                            <li><label>{{ $t('renovar_abono.tipo') }}</label> {{ $t('renovar_abono.asiento_anterior') }}</li>
                                            <li v-if="asiento.region"><label>{{ $t('general.sector') }}:</label> {{ asiento.region }}</li>
                                            <li v-if="asiento.row"><label>{{ $t('general.fila') }}:</label> {{ asiento.row }}</li>
                                            <li v-if="asiento.seat"><label>{{ $t('general.butaca') }}:</label> {{ asiento.seat }}</li>
                                            <li>
                                                <label>{{ $t('renovar_abono.disponibilidad') }}:</label>
                                                <strong v-if="asiento.ocupado != 1 && asiento.region_disponible" class="green">{{ $t('mapa.disponible') }}</strong>
                                                <strong v-else class="text-danger">{{ $t('mapa.no_disponible') }}</strong>
                                            </li>
                                        </ul>

                                        <router-link
                                            v-if="asiento.ocupado != 1 && asiento.region_disponible"
                                            class="button effect-button"
                                            :to="{ name: 'front.abonos.nuevo.index', query: { region_id: asiento.region_id, seat: asiento.seat, row: asiento.row, dni: abonado.dni, n_abonado_antiguo: abonado.n_abonado_antiguo }}"
                                        >
                                            <span>{{ $t('renovar_abono.renovar') }}</span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-4" v-if="plaza">
                                    <label class="d-block h5"><span class="altcolor">A</span>. {{ $t('renovar_abono.asiento_anterior') }}</label>
                                    <div class="lightgray-content p-2 p-lg-3 mb-3">
                                        <ul class="info-list list-unstyled w-100">
                                            <li><label>{{ $t('renovar_abono.tipo') }}</label> {{ $t('renovar_abono.asiento_anterior') }}</li>
                                            <li><label>{{ $t('general.sector') }}:</label> {{ plaza.region_name ? plaza.region_name : plaza.sector_name }}</li>
                                            <li><label>{{ $t('general.fila') }}:</label> {{ plaza.fila }}</li>
                                            <li><label>{{ $t('general.butaca') }}:</label> {{ plaza.butaca }}</li>
                                            <li>
                                                <label>{{ $t('renovar_abono.disponibilidad') }}:</label>
                                                <strong v-if="plaza.tipos_abonos" class="green">{{ $t('mapa.disponible') }}</strong>
                                                <strong v-else class="text-danger">{{ $t('mapa.no_disponible') }}</strong>
                                            </li>

                                        </ul>
                                        <router-link
                                            v-if="plaza.tipos_abonos"
                                            class="button effect-button"
                                            :to="{ name: 'front.abonos.nuevo.index', query: { region_id: plaza.region_id, plaza_id: plaza.id, dni: abonado.dni, n_abonado_antiguo: abonado.n_abonado_antiguo }}"
                                        >
                                            <span>{{ $t('renovar_abono.renovar') }}</span>
                                        </router-link>
                                    </div>
                                </div>
                                <div class="col-12 col-lg-8" v-if="!puede_cambiar_butaca">
                                    <label class="d-block h5"><span class="altcolor">{{ $t('renovar_abono.no_cambio') }}</span></label>
                                </div>
                                <div class="col-12 col-lg-8" v-else>
                                    <label class="d-block h5"><span class="altcolor">B</span>. {{ $t('renovar_abono.nuevo_asiento') }}</label>

                                    <!-- Tipo 1: SVG plano de zonas (existente) -->
                                    <div v-if="recinto.tipo_proceso_online != 2" class="lightgray-content p-2 p-lg-3 mb-3">
                                        <SvgComponent
                                            :zonas="zonas"
                                            :place="recinto"
                                            @clickZona="cambiarZona"
                                        />
                                    </div>

                                    <!-- Tipo 2: CTA directo al flujo de secciones (NUEVO) -->
                                    <div v-else class="p-2 p-lg-3 mb-3">
                                        <p>{{ $t('renovar_abono.seleccion_secciones') }}</p>
                                        <Button
                                            :label="$t('renovar_abono.continuar_seleccion')"
                                            @click="continuarRenovacionTipo2"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div v-if="teatro.familia_abonados_activa && !pertenece_a_familia && (asiento != null || plaza != null)" class="mt-4 pt-3 border-top">
                                <p>{{ $t('renovar_abono.familia_sin_grupo') }}</p>
                                <Button
                                    :label="$t('renovar_abono.familia_crear_grupo')"
                                    @click="openModalCrearFamilia"
                                />
                            </div>
                            <div v-else-if="teatro.familia_abonados_activa && !pertenece_a_familia && asiento == null && plaza == null" class="mt-4 pt-3 border-top">
                                <p class="text-black-50">{{ $t('renovar_abono.familia_sin_asiento_crear', { abonado: teatro.texto_abonado }) }}</p>
                            </div>
                        </div>
                        <template v-else>
                            <div style="height: 100px">
                                <LoaderComponent/>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </section>
        <section class="padding-vertical-content" v-if="error">
            <div class="container">
                <div class="row">
                    <div class="col-12" v-if="error == 300">
                        <h1>{{ $t('renovar_abono.ya_renovado', {abono: teatro.texto_abono}) }}</h1>
                    </div>
                    <div class="col-12" v-else>

                        <h1>{{ $t('renovar_abono.no_existe', {abonado: teatro.texto_abonado}) }}</h1>
                        <div v-if="configuracion.mensaje_renovacion" v-html="configuracion.mensaje_renovacion"></div>
                        <div v-else style="margin: 20px">
                            {{ $t('renovar_abono.escriba_correo', { email: this.footer.email_incidencias, abonado: teatro.texto_abonado }) }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <ModalComponent name="anadir-miembro" :title="$t('renovar_abono.familia_modal_titulo')" @close="cerrarModalAnadirMiembro">
            <!-- Paso 1: Formulario de validación -->
            <template v-if="!miembroValidado">
                <FormInput
                    :label="$t('renovar_abono.familia_modal_dni')"
                    name="dni"
                    rules="required"
                    v-model="nuevoMiembro.dni"
                />
                <FormInput
                    :label="$t('renovar_abono.familia_modal_n_abonado', { abonado: teatro.texto_abonado })"
                    name="n_abonado"
                    rules="required"
                    v-model="nuevoMiembro.n_abonado"
                />
                <div v-if="errorMiembro" class="alert alert-danger p-2 small mt-3">
                    <i class="fas fa-exclamation-triangle mr-1"></i> {{ errorMiembro }}
                </div>
                <div class="text-right mt-3">
                    <Button
                        :label="$t('renovar_abono.familia_modal_cancelar')"
                        custom-class="mr-2"
                        @click="cerrarModalAnadirMiembro"
                        :disabled="validandoMiembro"
                    />
                    <Button
                        v-if="!validandoMiembro"
                        :label="$t('renovar_abono.familia_modal_validar')"
                        :disabled="!nuevoMiembro.dni || !nuevoMiembro.n_abonado"
                        @click="confirmarAnadirMiembro"
                    />
                    <Button
                        v-else
                        :label="$t('renovar_abono.familia_modal_validando')"
                        disabled
                    />
                </div>
            </template>

            <!-- Paso 2: Confirmación para agregar a la familia -->
            <template v-else>
                <div class="alert alert-success small mb-3" role="alert">
                    <i class="fas fa-check-circle mr-1"></i>
                    {{ $t('renovar_abono.familia_modal_validado', { nombre: miembroValidado.name + ' ' + miembroValidado.surnames }) }}
                </div>
                <p>{{ $t('renovar_abono.familia_modal_pregunta_agregar') }}</p>
                <div v-if="errorAgregar" class="alert alert-danger p-2 small mt-3">
                    <i class="fas fa-exclamation-triangle mr-1"></i> {{ errorAgregar }}
                </div>
                <div class="text-right mt-3">
                    <Button
                        v-if="!agregandoMiembro"
                        :label="$t('renovar_abono.familia_modal_cancelar')"
                        custom-class="mr-2"
                        @click="cerrarModalAnadirMiembro"
                    />
                    <Button
                        v-if="!agregandoMiembro"
                        :label="$t('renovar_abono.familia_modal_agregar')"
                        @click="agregarMiembroAFamilia"
                    />
                    <Button
                        v-else
                        :label="$t('renovar_abono.familia_modal_agregando')"
                        disabled
                    />
                </div>
            </template>
        </ModalComponent>

        <ModalComponent name="crear-familia" :title="$t('renovar_abono.familia_crear_titulo')" @close="nombreFamilia = ''; errorCrearFamilia = ''">
            <FormInput
                :label="$t('renovar_abono.familia_crear_nombre')"
                name="nombre_familia"
                rules="required"
                v-model="nombreFamilia"
            />
            <div v-if="errorCrearFamilia" class="alert alert-danger p-2 small mt-3">
                <i class="fas fa-exclamation-triangle mr-1"></i> {{ errorCrearFamilia }}
            </div>
            <div class="text-right mt-3">
                <Button
                    :label="$t('renovar_abono.familia_modal_cancelar')"
                    custom-class="mr-2"
                    :disabled="creandoFamilia"
                    @click="$modal.hide('crear-familia')"
                />
                <Button
                    v-if="!creandoFamilia"
                    :label="$t('renovar_abono.familia_crear_confirmar')"
                    :disabled="!nombreFamilia.trim()"
                    @click="confirmarCrearFamilia"
                />
                <Button
                    v-else
                    :label="$t('renovar_abono.familia_creando')"
                    disabled
                />
            </div>
        </ModalComponent>

        <ModalComponent name="remover-miembro" :title="$t('renovar_abono.familia_remover_titulo')" @close="miembroARemover = null; eliminandoMiembro = false">
            <p class="mb-1">
                {{ $t('renovar_abono.familia_remover_pregunta', { nombre: miembroARemover?.name + ' ' + miembroARemover?.surnames }) }}
            </p>
            <p class="text-black-50 small mb-0">{{ $t('renovar_abono.familia_remover_confirmar') }}</p>
            <div class="text-right mt-3">
                <Button
                    :label="$t('renovar_abono.familia_modal_cancelar')"
                    custom-class="mr-2"
                    :disabled="eliminandoMiembro"
                    @click="$modal.hide('remover-miembro')"
                />
                <Button
                    v-if="!eliminandoMiembro"
                    :label="$t('renovar_abono.familia_modal_borrar')"
                    @click="confirmarRemoverMiembro"
                />
                <Button
                    v-else
                    :label="$t('renovar_abono.familia_modal_eliminando')"
                    disabled
                />
            </div>
        </ModalComponent>
    </div>
</template>

<script>
    import BuscarAbonadoComponent from '@/components/frontend/abonos/renovar/BuscarAbonadoComponent';
    import InformacionAbonadoComponent from '@/components/frontend/abonos/renovar/InformacionAbonadoComponent';
    import SvgComponent from '@/components/svg/SvgComponent';
    import Button from '@/modules/ui/Button.vue';
    import ToggleSwitch from '@/modules/front/ui/ToggleSwitch.vue';
    import ModalComponent from '@/components/backend/components/ModalComponent.vue';
    import FormInput from '@/components/common/FormInput.vue';
    import { useVersionMovil } from '@/composables/common/useVersionMovil';

    export default {
        setup() {
            const { esMovil } = useVersionMovil();
            return { esMovil };
        },
        props: [],
        data() {
            return {
                paso1: true,
                paso2: false,
                paso3: false,
                pasoFamilia: false,
                abonado_search: {
                    dni: null,
                    n_abonado_antiguo: null
                },
                abonado: null,
                asiento: null,
                plaza: null,
                error: false,
                loading: false,
                renovacion: false,
                yaRenovado: false,
                puede_cambiar_butaca: false,
                zonas: [],
                familias: null,
                familiares: [],
                familiaresSeleccionados: [],
                pertenece_a_familia: false,
                nuevoMiembro: {
                    n_abonado: '',
                    dni: ''
                },
                validandoMiembro: false,
                errorMiembro: '',
                miembroValidado: null,
                agregandoMiembro: false,
                errorAgregar: '',
                miembroARemover: null,
                eliminandoMiembro: false,
                cargandoFamilia: false,
                nombreFamilia: '',
                creandoFamilia: false,
                errorCrearFamilia: ''
            }
        },
        created() {
            if(this.$route.query.n_abonado_antiguo != null && this.$route.query.dni) {
                this.abonado_search.dni = this.$route.query.dni;
                this.abonado_search.n_abonado_antiguo = this.$route.query.n_abonado_antiguo;
                this.buscarAbonado();
                this.renovacion = 1;
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            puedeGestionarFamilia() {
                return this.familias?.titular_id === undefined || this.abonado?.id === this.familias?.titular_id;
            },
            miembrosDisponibles() {
                return this.familiares.filter(f => f.renovable && !f.renovado);
            },
            mostrarAvisoPreciosFamilia() {
                return this.miembrosDisponibles.length > 0 && !this.todosDisponiblesSeleccionados;
            },
            algunMiembroRenovado() {
                const miembros = this.familias?.miembros;
                return Array.isArray(miembros) && miembros.some(m => m && m.renovado);
            },
            todosDisponiblesSeleccionados() {
                const disponibles = this.miembrosDisponibles;
                return disponibles.length > 0 && disponibles.every(f => this.familiaresSeleccionados.includes(f.id));
            },
            totalSeleccionados() {
                return this.familiaresSeleccionados.length + 1;
            },
            ubicacionAbonadoPrincipal() {
                return this.ubicacionFamiliar({ asiento: this.asiento, plaza: this.plaza });
            },
            estadoBadge() {
                const estado = this.familias?.estado;
                if (!estado) return null;
                const map = {
                    aprobado: {
                        variant: 'badge-success',
                        label: this.$t('renovar_abono.familia_estado_aprobada'),
                        info: this.$t('renovar_abono.familia_estado_aprobada_info')
                    },
                    pendiente: {
                        variant: 'badge-warning',
                        label: this.$t('renovar_abono.familia_estado_pendiente'),
                        info: this.$t('renovar_abono.familia_estado_pendiente_info')
                    },
                    rechazado: {
                        variant: 'badge-danger',
                        label: this.$t('renovar_abono.familia_estado_rechazada'),
                        info: this.$t('renovar_abono.familia_estado_rechazada_info')
                    },
                };
                return map[estado] ?? { variant: 'badge-secondary', label: estado, info: '' };
            }
        },
        methods: {
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: 1
                    },
                    tid: this.configuracion.hash_teatro,
                    renovacion: 1
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.index'), params).then(res => {
                    this.zonas = res.data.data;
                    if (this.recinto) {
                        this.getZonasAnexas();
                    } else {
                        this.loading = false;
                    }
                    this.paso3 = true;
                    this.$nextTick(() => {
                        this.$scrollTo('#paso3', 150);
                    });
                });
            },
            getZonasAnexas() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        renovacion: 1
                    },
                    lista_id: this.lista_abonados.id,
                    recinto_id: this.recinto.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.recinto.regiones.anexas'), params).then(res => {
                    let anexas = res.data.data;

                    anexas.forEach(zona => {
                        zona.precios = []; 
                        zona.tipos_abonos.forEach(precio => {
                            zona.precios = zona.precios.concat(precio.descuentos);
                        });
                    });
                
                    this.zonas = this.zonas.concat(anexas);
                }).finally(() => this.loading = false);
            },
            buscarAbonado() {
                this.loading = true;
                this.yaRenovado = false;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado_search.dni,
                        n_abonado_antiguo: this.abonado_search.n_abonado_antiguo
                    },
                    tid: this.configuracion.hash_teatro,
                    dni: this.abonado_search.dni,
                    n_abonado_antiguo: this.abonado_search.n_abonado_antiguo
                }

                const session_id = sessionStorage.getItem('session_id');

                if (session_id) {
                    params.session_id = session_id;
                    params.filters.session_id = session_id;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                    // Si el abonado ya está activo en la temporada actual, no permitir continuar
                    if (res.data.abonado?.activo_temporada_actual) {
                        this.yaRenovado = true;
                        this.loading = false;
                        this.cargandoFamilia = false;
                        return;
                    }

                    this.abonado = res.data.abonado;
                    this.puede_cambiar_butaca = res.data.puede_cambiar_butaca;
                    this.asiento = res.data.asiento;
                    this.plaza = res.data.plaza;
                    this.familias = res.data.familia || null;
                    this.pertenece_a_familia = res.data.pertenece_a_familia || false;

                    if (this.plaza) {
                        this.plaza.tipos_abonos = res.data.tipos_abonos;
                    }

                    if(!this.abonado) {
                        this.error = res.data.message;
                        this.$nextTick(() => {
                            this.$scrollTo('body', 100);
                        });
                    } else {
                        this.error = false;
                    }

                    if (this.teatro?.familia_abonados_activa && this.pertenece_a_familia && (this.asiento != null || this.plaza != null)) {
                        this.cargarFamiliares();
                        this.pasoFamilia = true;
                        this.$nextTick(() => {
                            this.$scrollTo('#pasoFamilia', 600);
                        });
                        this.loading = false;
                        this.cargandoFamilia = false;
                        this.paso2 = true;
                    } else {
                        this.getZonas();
                        this.loading = false;
                        this.cargandoFamilia = false;
                        this.paso2 = true;
                    }
                }).catch(error => {
                    this.error = error.response?.status || 500;
                    this.loading = false;
                    this.cargandoFamilia = false;
                });
            },
            cargarFamiliares() {
                const miembros = this.familias?.miembros || [];
                this.familiares = miembros.map(m => ({
                    id: m.id,
                    name: m.name || '',
                    surnames: m.surnames || '',
                    dni: m.dni || '',
                    n_abonado: m.n_abonado || '',
                    n_abonado_antiguo: m.n_abonado_antiguo || m.n_abonado || '',
                    renovado: m.renovado || false,
                    renovable: m.renovable !== false,
                    asiento: m.asiento || null,
                    plaza: m.plaza || null
                }));

                this.familiaresSeleccionados = [];
            },
            ubicacionFamiliar(familiar) {
                if (familiar.asiento) {
                    const a = familiar.asiento;
                    const region = a.region || a.zona || '';
                    const row = a.fila || a.row || '';
                    const seat = a.butaca || a.seat || '';
                    if ((row == 0 || row === '0') && (seat == 0 || seat === '0')) {
                        return (region ? region + ' — ' : '') + 'Sin numerar';
                    }
                    if (!row && !seat) {
                        return region || this.$t('renovar_abono.familia_sin_ubicacion');
                    }
                    return (region ? region + ' | ' : '') + 'Fila ' + row + ' — Butaca ' + seat;
                }

                if (familiar.plaza) {
                    const p = familiar.plaza;
                    const zona = p.region_name || p.zona || p.sector || '';
                    const row = p.fila || '';
                    const seat = p.butaca || '';
                    if ((row == 0 || row === '0') && (seat == 0 || seat === '0')) {
                        return (zona ? zona + ' — ' : '') + 'Sin numerar';
                    }
                    if (!row && !seat) {
                        return zona || this.$t('renovar_abono.familia_sin_ubicacion');
                    }
                    return (zona ? zona + ' | ' : '') + 'Fila ' + row + ' — Butaca ' + seat;
                }

                return this.$t('renovar_abono.familia_sin_ubicacion');
            },
            toggleFamiliar(id) {
                const index = this.familiaresSeleccionados.indexOf(id);
                if (index === -1) {
                    this.familiaresSeleccionados.push(id);
                } else {
                    this.familiaresSeleccionados.splice(index, 1);
                }
            },
            seleccionarTodosFamiliares() {
                const disponibles = this.miembrosDisponibles;
                if (this.todosDisponiblesSeleccionados) {
                    // Deseleccionar solo los disponibles
                    const disponiblesIds = new Set(disponibles.map(f => f.id));
                    this.familiaresSeleccionados = this.familiaresSeleccionados.filter(id => !disponiblesIds.has(id));
                } else {
                    // Seleccionar todos los disponibles
                    const disponiblesIds = disponibles.map(f => f.id);
                    const yaSeleccionados = new Set(this.familiaresSeleccionados);
                    disponiblesIds.forEach(id => yaSeleccionados.add(id));
                    this.familiaresSeleccionados = Array.from(yaSeleccionados);
                }
            },
            continuarSinFamilia() {
                // Only include abonado_ids when there are family members selected
                if (this.familiaresSeleccionados.length) {
                    const ids = [this.abonado.id, ...this.familiaresSeleccionados];

                    const selectedData = this.familiares
                        .filter(f => this.familiaresSeleccionados.includes(f.id))
                        .map(f => ({
                            id: f.id,
                            name: f.name,
                            surnames: f.surnames,
                            dni: f.dni,
                            n_abonado: f.n_abonado,
                            n_abonado_antiguo: f.n_abonado_antiguo,
                            asiento: f.asiento,
                            plaza: f.plaza
                        }));
                    sessionStorage.setItem('familia_seleccionados', JSON.stringify(selectedData));

                    this.$router.push({
                        name: 'front.abonos.nuevo.index',
                        query: {
                            dni: this.abonado.dni,
                            n_abonado_antiguo: this.abonado.n_abonado_antiguo,
                            abonado_ids: ids.join(',')
                        }
                    });
                } else {
                    // No family selected — show normal renovation paso3 (same as no-family flow)
                    this.pasoFamilia = false;
                    this.getZonas();
                }
            },
            volverAPasoFamilia() {
                this.paso3 = false;
                this.pasoFamilia = true;
                this.$nextTick(() => {
                    this.$scrollTo('#pasoFamilia', 600);
                });
            },
            volverAlBuscar() {
                this.abonado = null;
                this.asiento = null;
                this.plaza = null;
                this.error = false;
                this.yaRenovado = false;
                this.paso3 = false;
                this.paso2 = false;
                this.pasoFamilia = false;
                this.paso1 = true;
                this.familiares = [];
                this.familiaresSeleccionados = [];
                this.zonas = [];
                this.$nextTick(() => {
                    this.$scrollTo('body', 100);
                });
            },
            quitarMiembro(id) {
                const index = this.familiares.findIndex(f => f.id === id && f.nuevo);
                if (index !== -1) {
                    this.familiares.splice(index, 1);
                    const selIndex = this.familiaresSeleccionados.indexOf(id);
                    if (selIndex !== -1) {
                        this.familiaresSeleccionados.splice(selIndex, 1);
                    }
                }
            },
            openModalCrearFamilia() {
                this.nombreFamilia = '';
                this.errorCrearFamilia = '';
                this.$modal.show('crear-familia');
            },
            confirmarCrearFamilia() {
                if (!this.nombreFamilia.trim() || this.creandoFamilia) return;

                this.creandoFamilia = true;
                this.errorCrearFamilia = '';

                const params = {
                    abonado_id: this.abonado.id,
                    abonado_agregado_id: this.abonado.id,
                    nombre: this.nombreFamilia.trim()
                };

                this.$store.dispatch(this.config.getVuexAlias('front.abonos.crear-familia'), params)
                    .then(res => {
                        this.$toast.success(this.$t('renovar_abono.familia_crear_exito'));
                        this.$modal.hide('crear-familia');
                        this.nombreFamilia = '';
                        this.creandoFamilia = false;
                        this.cargandoFamilia = true;
                        this.buscarAbonado();
                    })
                    .catch(error => {
                        const msg = error.response?.data?.message || error.response?.data?.error || this.$t('renovar_abono.familia_crear_error');
                        this.errorCrearFamilia = msg;
                        this.creandoFamilia = false;
                    });
            },
            openModalAnadirMiembro() {
                this.nuevoMiembro = { n_abonado: '', dni: '' };
                this.errorMiembro = '';
                this.miembroValidado = null;
                this.errorAgregar = '';
                this.$modal.show('anadir-miembro');
            },
            cerrarModalAnadirMiembro() {
                this.miembroValidado = null;
                this.errorAgregar = '';
                this.$modal.hide('anadir-miembro');
            },
            openModalRemoverMiembro(familiar) {
                this.miembroARemover = familiar;
                this.$modal.show('remover-miembro');
            },
            confirmarRemoverMiembro() {
                if (!this.miembroARemover || this.eliminandoMiembro) return;

                this.eliminandoMiembro = true;

                const params = {
                    abonado_id: this.abonado.id,
                    abonado_removido_id: this.miembroARemover.id
                };

                this.$store.dispatch(this.config.getVuexAlias('front.abonos.remover-miembro'), params)
                    .then(res => {
                        this.$toast.success(this.$t('renovar_abono.familia_remover_exito'));
                        this.$modal.hide('remover-miembro');
                        this.miembroARemover = null;
                        this.eliminandoMiembro = false;
                        this.cargandoFamilia = true;
                        this.buscarAbonado();
                    })
                    .catch(error => {
                        const msg = error.response?.data?.message || error.response?.data?.error || this.$t('renovar_abono.familia_remover_error');
                        this.$toast.error(msg);
                        this.eliminandoMiembro = false;
                    });
            },
            confirmarAnadirMiembro() {
                this.validandoMiembro = true;
                this.errorMiembro = '';

                const params = {
                    n_abonado: this.nuevoMiembro.n_abonado,
                    dni: this.nuevoMiembro.dni
                };

                this.$store.dispatch(this.config.getVuexAlias('front.abonos.validar-miembro'), params)
                    .then(res => {
                        const miembro = res.data?.data || res.data;

                        // Guardamos los datos validados para el paso de confirmación
                        this.miembroValidado = {
                            id: miembro.id,
                            name: miembro.name || '',
                            surnames: miembro.surnames || '',
                            dni: miembro.dni || '',
                            n_abonado: miembro.n_abonado || ''
                        };
                    })
                    .catch(error => {
                        if (error.response?.data?.message) {
                            this.errorMiembro = error.response.data.message;
                        } else if (error.response?.data?.error) {
                            this.errorMiembro = error.response.data.error;
                        } else {
                            this.errorMiembro = this.$t('renovar_abono.familia_modal_error');
                        }
                    })
                    .finally(() => {
                        this.validandoMiembro = false;
                    });
            },
            agregarMiembroAFamilia() {
                this.agregandoMiembro = true;
                this.errorAgregar = '';

                const params = {
                    abonado_id: this.abonado.id,
                    abonado_agregado_id: this.miembroValidado.id,
                    n_abonado: this.miembroValidado.n_abonado,
                    dni: this.miembroValidado.dni
                };

                this.$store.dispatch(this.config.getVuexAlias('front.abonos.agregar-miembro'), params)
                    .then(res => {
                        this.$toast.success(this.$t('renovar_abono.familia_modal_agregado_exito'));
                        this.$modal.hide('anadir-miembro');
                        this.miembroValidado = null;
                        this.errorAgregar = '';
                        // Refrescamos los datos del abonado para que traiga los miembros actualizados
                        this.cargandoFamilia = true;
                        this.buscarAbonado();
                    })
                    .catch(error => {
                        if (error.response?.data?.message) {
                            this.errorAgregar = error.response.data.message;
                        } else if (error.response?.data?.error) {
                            this.errorAgregar = error.response.data.error;
                        } else {
                            this.errorAgregar = this.$t('renovar_abono.familia_modal_error_agregar');
                        }
                    })
                    .finally(() => {
                        this.agregandoMiembro = false;
                    });
            },
            cambiarZona(zona) {
                const query = {
                    region_id: zona.id,
                    seleccion_zona: 1,
                    dni: this.abonado.dni,
                    n_abonado_antiguo: this.abonado.n_abonado_antiguo
                };
                if (this.familiaresSeleccionados.length) {
                    query.abonado_ids = this.familiaresSeleccionados.join(',');
                }
                this.$router.push({ name: 'front.abonos.nuevo.index', query });
            },
            continuarRenovacionTipo2() {
                const query = {
                    dni: this.abonado.dni,
                    n_abonado_antiguo: this.abonado.n_abonado_antiguo
                };
                if (this.familiaresSeleccionados.length) {
                    query.abonado_ids = this.familiaresSeleccionados.join(',');
                }
                this.$router.push({ name: 'front.abonos.nuevo.index', query });
            }
        },
        components: {
            BuscarAbonadoComponent, InformacionAbonadoComponent, SvgComponent, Button, ToggleSwitch, ModalComponent, FormInput
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .familia-loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
    }
</style>
